 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER2001ELEMENTALENERGYOFHEAVENANDEARTH from '@/components/0_chapter2001elementalenergyofheavenandearth'
 import A_CHAPTER2002BLACKCASTLE from '@/components/1_chapter2002blackcastle'
 import A_CHAPTER2003SUSPICION from '@/components/2_chapter2003suspicion'
 import A_CHAPTER2004OLDTEXT from '@/components/3_chapter2004oldtext'
 import A_CHAPTER2005ALIENDESCENT from '@/components/4_chapter2005aliendescent'
 import A_CHAPTER2006RIVERANDMOUNTAINDIAGRAM from '@/components/5_chapter2006riverandmountaindiagram'
 import A_CHAPTER2007BOTHAREEMPTY from '@/components/6_chapter2007bothareempty'
 import A_CHAPTER2008HOLLOWSACREDFIRE from '@/components/7_chapter2008hollowsacredfire'
 import A_CHAPTER2009MOTHEROFHOLLOWFLAMES from '@/components/8_chapter2009motherofhollowflames'
 import A_CHAPTER2010VIRGINOFNOTHINGNESS from '@/components/9_chapter2010virginofnothingness'
 import A0_CHAPTER2011EPOCHCONTRAST from '@/components/10_chapter2011epochcontrast'
 import A1_CHAPTER2012PENETRATINGSPACEANDTIME from '@/components/11_chapter2012penetratingspaceandtime'
 import A2_CHAPTER2013DETERMINATION from '@/components/12_chapter2013determination'
 import A3_CHAPTER2014TERRIFYINGPOWER from '@/components/13_chapter2014terrifyingpower'
 import A4_CHAPTER2015ON from '@/components/14_chapter2015on'
 import A5_CHAPTER2016THREEPEOPLEGOINGTOGETHER from '@/components/15_chapter2016threepeoplegoingtogether'
 import A6_CHAPTER2017PENETRATINGSPACEANDTIME from '@/components/16_chapter2017penetratingspaceandtime'
 import A7_CHAPTER2018FIVEDISEASESOFNATURE from '@/components/17_chapter2018fivediseasesofnature'
 import A8_CHAPTER2019UNKNOWNCULTIVATIONMETHOD from '@/components/18_chapter2019unknowncultivationmethod'
 import A9_CHAPTER2020FIVEDISEASESOFNATURE from '@/components/19_chapter2020fivediseasesofnature'
 import A0_CHAPTER2021TERRIFYINGAURAOFDECAY from '@/components/20_chapter2021terrifyingauraofdecay'
 import A1_CHAPTER2022SUPERPOSITION from '@/components/21_chapter2022superposition'
 import A2_CHAPTER2023SIXTH from '@/components/22_chapter2023sixth'
 import A3_CHAPTER2024BADSITUATION from '@/components/23_chapter2024badsituation'
 import A4_CHAPTER2025DESTRUCTION from '@/components/24_chapter2025destruction'
 import A5_CHAPTER2026DIVINEPOWER from '@/components/25_chapter2026divinepower'
 import A6_CHAPTER2027GOODFORTUNEPILL from '@/components/26_chapter2027goodfortunepill'
 import A7_CHAPTER2028THEFOUROVERGODS from '@/components/27_chapter2028thefourovergods'
 import A8_CHAPTER2029DECISIONTRANSFER from '@/components/28_chapter2029decisiontransfer'
 import A9_CHAPTER2030THEAGEOFELEMENTALENERGY from '@/components/29_chapter2030theageofelementalenergy'
 import A0_CHAPTER2031DEMONESS from '@/components/30_chapter2031demoness'
 import A1_CHAPTER2032THESITUATIONISRATHERGRIM from '@/components/31_chapter2032thesituationisrathergrim'
 import A2_CHAPTER2033SKINHEAD from '@/components/32_chapter2033skinhead'
 import A3_CHAPTER2034CELESTIALDOMAIN from '@/components/33_chapter2034celestialdomain'
 import A4_CHAPTER2035EMPTYPHASE from '@/components/34_chapter2035emptyphase'
 import A5_CHAPTER2036GODLYARMSMOUNTAIN from '@/components/35_chapter2036godlyarmsmountain'
 import A6_CHAPTER2037COOPERATION from '@/components/36_chapter2037cooperation'
 import A7_CHAPTER2038HELPLESSNESS from '@/components/37_chapter2038helplessness'
 import A8_CHAPTER2039ICEBODY from '@/components/38_chapter2039icebody'
 import A9_CHAPTER2040SPATIALTRANSFER from '@/components/39_chapter2040spatialtransfer'
 import A0_CHAPTER2041DRAGONSLAYINGKNIFE from '@/components/40_chapter2041dragonslayingknife'
 import A1_CHAPTER2042HETEROSPATIALSPACE from '@/components/41_chapter2042heterospatialspace'
 import A2_CHAPTER2043TWOPEOPLE from '@/components/42_chapter2043twopeople'
 import A3_CHAPTER2044REENCOUNTER from '@/components/43_chapter2044reencounter'
 import A4_CHAPTER2045RESENTMENT from '@/components/44_chapter2045resentment'
 import A5_CHAPTER2046PRAIRIEFIRE from '@/components/45_chapter2046prairiefire'
 import A6_CHAPTER2047SPACEGATE from '@/components/46_chapter2047spacegate'
 import A7_CHAPTER2048DEFEATSITUJIN from '@/components/47_chapter2048defeatsitujin'
 import A8_CHAPTER2049MYSTERIOUSPLACE from '@/components/48_chapter2049mysteriousplace'
 import A9_CHAPTER2050DETECTION from '@/components/49_chapter2050detection'
 import A0_CHAPTER2051UNDEADORGANISM from '@/components/50_chapter2051undeadorganism'
 import A1_CHAPTER2052DEMONSMOUTH from '@/components/51_chapter2052demonsmouth'
 import A2_CHAPTER2053TREASURETROVE from '@/components/52_chapter2053treasuretrove'
 import A3_CHAPTER2054COLLECT from '@/components/53_chapter2054collect'
 import A4_CHAPTER2055STRANGEBOX from '@/components/54_chapter2055strangebox'
 import A5_CHAPTER2056BADSITUATION from '@/components/55_chapter2056badsituation'
 import A6_CHAPTER2057MAJORSECTIONING from '@/components/56_chapter2057majorsectioning'
 import A7_CHAPTER2058NOCTURNALSONG from '@/components/57_chapter2058nocturnalsong'
 import A8_CHAPTER2059FIGHT from '@/components/58_chapter2059fight'
 import A9_CHAPTER2060KILLINGINALLDIRECTIONS from '@/components/59_chapter2060killinginalldirections'
 import A0_CHAPTER2061EXTINCTIONSLASH from '@/components/60_chapter2061extinctionslash'
 import A1_CHAPTER2062METATHESIS from '@/components/61_chapter2062metathesis'
 import A2_CHAPTER2063PUREYUANSUPREMETREASURE from '@/components/62_chapter2063pureyuansupremetreasure'
 import A3_CHAPTER2064NAHORSBRIDGE from '@/components/63_chapter2064nahorsbridge'
 import A4_CHAPTER2065INJURIESTOBOTHSIDES from '@/components/64_chapter2065injuriestobothsides'
 import A5_CHAPTER2066DRAGONSLAYINGKNIFEADVANCED from '@/components/65_chapter2066dragonslayingknifeadvanced'
 import A6_CHAPTER2067TIANYUANCITY from '@/components/66_chapter2067tianyuancity'
 import A7_CHAPTER2068DRUNKENMOONRESTAURANT from '@/components/67_chapter2068drunkenmoonrestaurant'
 import A8_CHAPTER2069PRINCESSZUIYUE from '@/components/68_chapter2069princesszuiyue'
 import A9_CHAPTER2070NOCTURNALSONG from '@/components/69_chapter2070nocturnalsong'
 import A0_CHAPTER2071SHOCKEDCROWD from '@/components/70_chapter2071shockedcrowd'
 import A1_CHAPTER2072WARNIGHTSONGSAGAIN from '@/components/71_chapter2072warnightsongsagain'
 import A2_CHAPTER2073SUPPRESSING from '@/components/72_chapter2073suppressing'
 import A3_CHAPTER2074NOTGOOD from '@/components/73_chapter2074notgood'
 import A4_CHAPTER2075CONSPIRACY from '@/components/74_chapter2075conspiracy'
 import A5_CHAPTER2076TITAN from '@/components/75_chapter2076titan'
 import A6_CHAPTER2077EMPEROR from '@/components/76_chapter2077emperor'
 import A7_CHAPTER2078CALCULATION from '@/components/77_chapter2078calculation'
 import A8_CHAPTER2079AUCTION from '@/components/78_chapter2079auction'
 import A9_CHAPTER2080PEAK from '@/components/79_chapter2080peak'
 import A0_CHAPTER2081SOULGATHERINGLAMP from '@/components/80_chapter2081soulgatheringlamp'
 import A1_CHAPTER2082CHINESELEOPARDSEED from '@/components/81_chapter2082chineseleopardseed'
 import A2_CHAPTER2083ROYALPHOENIXBLOOD from '@/components/82_chapter2083royalphoenixblood'
 import A3_CHAPTER2084HANDS from '@/components/83_chapter2084hands'
 import A4_CHAPTER2085GRADENINEMEDICINALPILL from '@/components/84_chapter2085gradeninemedicinalpill'
 import A5_CHAPTER2086FINALAUCTIONITEM from '@/components/85_chapter2086finalauctionitem'
 import A6_CHAPTER2087METACHRONISM from '@/components/86_chapter2087metachronism'
 import A7_CHAPTER2088AUCTIONITEMS from '@/components/87_chapter2088auctionitems'
 import A8_CHAPTER2089GREATRETURNINGTECHNIQUE from '@/components/88_chapter2089greatreturningtechnique'
 import A9_CHAPTER2090LONGCHANDAN from '@/components/89_chapter2090longchandan'
 import A0_CHAPTER2091ENDOFAUCTION from '@/components/90_chapter2091endofauction'
 import A1_CHAPTER2092EXPOSURE from '@/components/91_chapter2092exposure'
 import A2_CHAPTER2093VIRULENCE from '@/components/92_chapter2093virulence'
 import A3_CHAPTER2094TRUEBODY from '@/components/93_chapter2094truebody'
 import A4_CHAPTER2095FUSION from '@/components/94_chapter2095fusion'
 import A5_CHAPTER2096SPIRITANDSPIRITCOLLISION from '@/components/95_chapter2096spiritandspiritcollision'
 import A6_CHAPTER2097GREATCURSE from '@/components/96_chapter2097greatcurse'
 import A7_CHAPTER2098FIVEHUNDREDYEARS from '@/components/97_chapter2098fivehundredyears'
 import A8_CHAPTER2099SHUNYANSAWAKENING from '@/components/98_chapter2099shunyansawakening'
 import A9_CHAPTER2100TAIYANDIVINEREGION from '@/components/99_chapter2100taiyandivineregion'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter2001elementalenergyofheavenandearth",
 			"name" : "0_chapter2001elementalenergyofheavenandearth",
 			"component" : A_CHAPTER2001ELEMENTALENERGYOFHEAVENANDEARTH
 		},
 		{
 			"path" : "/1_chapter2002blackcastle",
 			"name" : "1_chapter2002blackcastle",
 			"component" : A_CHAPTER2002BLACKCASTLE
 		},
 		{
 			"path" : "/2_chapter2003suspicion",
 			"name" : "2_chapter2003suspicion",
 			"component" : A_CHAPTER2003SUSPICION
 		},
 		{
 			"path" : "/3_chapter2004oldtext",
 			"name" : "3_chapter2004oldtext",
 			"component" : A_CHAPTER2004OLDTEXT
 		},
 		{
 			"path" : "/4_chapter2005aliendescent",
 			"name" : "4_chapter2005aliendescent",
 			"component" : A_CHAPTER2005ALIENDESCENT
 		},
 		{
 			"path" : "/5_chapter2006riverandmountaindiagram",
 			"name" : "5_chapter2006riverandmountaindiagram",
 			"component" : A_CHAPTER2006RIVERANDMOUNTAINDIAGRAM
 		},
 		{
 			"path" : "/6_chapter2007bothareempty",
 			"name" : "6_chapter2007bothareempty",
 			"component" : A_CHAPTER2007BOTHAREEMPTY
 		},
 		{
 			"path" : "/7_chapter2008hollowsacredfire",
 			"name" : "7_chapter2008hollowsacredfire",
 			"component" : A_CHAPTER2008HOLLOWSACREDFIRE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js